import slugify from 'react-slugify';
import preEtapaIconUrl from './../assets/images/svg/pre-etapa-icon.svg';
import icon2Url from './../assets/images/svg/etapa-2-icon.svg';
import icon3Url from './../assets/images/svg/etapa-3-icon.svg';
import icon4_7Url from './../assets/images/svg/etapa-4-7-icon.svg';
import icon5Url from './../assets/images/svg/etapa-5-icon.svg';
import icon6Url from './../assets/images/svg/etapa-6-icon.svg';
import icon8Url from './../assets/images/svg/etapa-8-icon.svg';
import icon9Url from './../assets/images/svg/etapa-9-icon.svg';

export const allSteps = [];
allSteps[0] = 'Pré Cadastro';
allSteps[1] = 'Etapa 1';
allSteps[2] = 'Etapa 2.1';
allSteps[3] = 'Etapa 2.2';
allSteps[4] = 'Etapa 3';
allSteps[5] = 'Etapa 4';
allSteps[6] = 'Etapa 5';
allSteps[7] = 'Etapa 6';
allSteps[8] = 'Etapa 7';
allSteps[9] = 'Etapa 8';
allSteps[10] = 'Etapa 9';

export const getStepIconByIndex = (index) => {
  return [
    preEtapaIconUrl,
    preEtapaIconUrl,
    icon2Url,
    icon2Url,
    icon3Url,
    icon4_7Url,
    icon5Url,
    icon6Url,
    icon4_7Url,
    icon8Url,
    icon9Url,
  ][index];
};

export function getStepName(index) {
  if (index < allSteps.length) {
    return allSteps[index];
  }
  return null;
}

export function getStepSlug(index) {
  var name = getStepName(index);
  if (name) {
    name = name.split('.').join('-');
    return slugify(name);
  }
  return null;
}

export function getStepIndexByStepSlug(slug) {
  var currStepIndex = 0;
  allSteps.forEach((step, index) => {
    if (getStepSlug(index) === slug) {
      currStepIndex = index;
    }
  });
  return currStepIndex;
}
